<template>
  <div>
    <!-- Advanced/simplified problem reporting -->
    <ExpandableSettingsItem :title="$t('message.SETTINGS_PROBLEMS_MODE')">
      <div>
        {{ $t("message.DEFAULT_PROBLEM_MODE") }}
        <RadioGroup
          :value="currentTeam.defaultReportingMode"
          :items="modeRadioItems"
          @input="setParams('defaultReportingMode', $event)"
        />
      </div>
    </ExpandableSettingsItem>

    <!-- Customize problem reporting hints -->
    <ExpandableSettingsItem :title="$t('message.CUSTOM_PROBLEM_HINTS')">
      <ProblemHintsEdition
        :hints="currentTeam.customProblemHints"
        :problem-sheet="currentTeam.customHintsProblemSheet"
        company-settings-choice
        @hintsUpdated="setParams('customProblemHints', $event)"
        @problemSheetUpdated="setParams('customHintsProblemSheet', $event)"
      />
    </ExpandableSettingsItem>
  </div>
</template>

<script>
/**
 * Settings > Problems
 * Allow editing:
 * - default reporting mode
 * - problem reporting hints
 */

// Components
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import ProblemHintsEdition from '@/components/problem-hints-edition.vue';
import RadioGroup from '@/components/radio-group.vue';
// Vuex utils
import { SET_TEAM_PARAM } from '@/store/action-types';

export default {

  name: 'SettingsProblems',

  components: {
    ExpandableSettingsItem,
    ProblemHintsEdition,
    RadioGroup,
  },

  data() {
    return {
      modeRadioItems: [
        { id: 0, label: this.$t('message.SIMPLIFIED_MODE') },
        { id: 1, label: this.$t('message.ADVANCED_MODE') },
      ],
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.SETTINGS_PROBLEMS'),
    };
  },

  methods: {
    /** Set company params */
    setParams(field, value) {
      this.$store.dispatch(SET_TEAM_PARAM, { [field]: value });
    },
  },
};
</script>
